<template>
  <div>
    <el-row type="flex" class="edm-row">
      <p class="title">
        {{ user ? 'ЭЦП ПОЛЬЗОВАТЕЛЯ:' : 'Найден в контрагентах:' }}
      </p>
      <div class="edm-contr">
        <p>{{ contragent.org_name }}</p>
        <p>Договор № {{ contragent.docNumber }}</p>
      </div>
    </el-row>
    <template v-if="user">
      <el-row type="flex" class="edm-row">
        <p class="title width170">ТЕЛЕФОН:</p>
        <div class="edm-contr">
          <p>
            <input
              v-mask="'+7 (###) ###-##-##'"
              class="doc-phone"
              :value="user.phone"
              masked="true"
              readonly
            />
          </p>
        </div>
      </el-row>
    </template>
  </div>
</template>

<script>
export default {
  name: 'EdmUserInfo',
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    contragent: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
